
export default (store) => ({
  path: 'interstitial',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const Interstitial = require('./components/Interstitial').default

      /*  Return getComponent   */
      cb(null, Interstitial)

    /* Webpack named bundle   */
    }, 'Interstitial')
  }
})



/** WEBPACK FOOTER **
 ** ./src/routes/Auth/routes/Discovery/routes/HealthAndHappinessTool/routes/Interstitial/index.js
 **/